import React, {PureComponent} from 'react';
import PrivacyView from './view';

class Privacy extends PureComponent{
    constructor(props){
        super(props);

        this.state={};
    }
    render(){
        return (
            <PrivacyView/>
        )
    }
}

export default Privacy;


// WEBPACK FOOTER //
// ./src/scenes/Privacy/index.js